import React from "react";

/**
 * Live-row kicker: an animated red broadcast dot + "Streaming live". The dot
 * carries the live cue; the text inherits the section kicker's gold so it stays
 * consistent with every other header. The ping animation is the only motion and
 * is decorative, so it needs no reduced-motion gate beyond the trivial-micro
 * threshold.
 */
const LiveKicker = () => (
  <span className="inline-flex items-center gap-1.5 align-middle">
    <span className="relative flex h-1.5 w-1.5">
      <span className="absolute inline-flex h-full w-full rounded-full bg-red-500 opacity-75 animate-ping motion-reduce:animate-none" />
      <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-red-500" />
    </span>
    Streaming live
  </span>
);

export default LiveKicker;
